module.exports = __webpack_public_path__ + "static/media/17.d50bee01.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/17.png
// module id = 1455
// module chunks = 0